(function () {
  'use strict';

  /* @ngdoc object
   * @name adminCrewBatchers
   * @description
   *
   */
  angular
    .module('adminCrewBatchers', [
      'ui.router'
    ]);
}());
